export const partners = [
    {
        company: 'Amazon',
        header: 'Amazon Business',
        logo: require('@assets/images/logo-amazon-business.jpg'),
        description: 'Amazon Business is changing the way companies buy supplies. Amazon Business can assist in finding the best product at the best price with the most convenient payment terms.', // eslint-disable-line max-len
        linkText: 'Learn How',
        link: 'https://www.amazon.com/tryAB?utm_source=dnb_customer_portal&ref_=assoc_tag_ph_1524210604088&_encoding=UTF8&camp=1789&creative=9325&linkCode=pf4&tag=aballiancesdn-20&linkId=8c8836b9870152b8cc78404974111984'// eslint-disable-line max-len
    },
    {
        company: 'KPMG',
        header: 'KPMG Spark Managed Accounting',
        logo: require('@assets/images/logo-kpmg-spark.jpg'),
        description: 'KPMG Spark is a managed accounting solution built to help you save time and money. Connect your accounts and let our financial professionals manage your books.', // eslint-disable-line max-len
        linkText: 'Schedule A Consult',
        link: 'https://info.kpmgspark.com/db?utm_source=dnb_customer_portal'
    },
    {
        company: 'Vintro',
        header: 'Vintro',
        logo: require('@assets/images/logo-vintro.svg'),
        description: 'Reach the high-profile leaders and investors you need to grow. With Vintro, we guarantee you their direct time and attention.', // eslint-disable-line max-len
        linkText: 'Learn More',
        link: 'https://beta.myvintro.com/?utm_source=dnb_customer_portal&utm_medium=tile&utm_campaign=exchange'
    }
];

export const applicationTypes = ['Associate-a-DUNS', 'Get-a-DUNS'];

export const partnerPlacementsGoogleAdConfigList = {
    desktop: [
        {
            slot: '/22150725263/364x422-MyDNB-GAD-Offer-Desktop-1',
            width: 364,
            height: 422,
            ad_id: 'div-gpt-ad-1674608591069-0',
            className: 'rounded google-ads',
            key: 'desktop_1',
            ad_type: '',
            countryCodeEnabled: ['US'],
            style: {
                background: '#FFFFFF',
                border: '0.893041px solid #CBCDCE',
                borderRadius: '8px'
            }
        },
        {
            slot: '/22150725263/364x422-MyDNB-GAD-Offer-Desktop-2',
            width: 364,
            height: 422,
            ad_id: 'div-gpt-ad-1663866872692-0',
            className: 'rounded google-ads',
            key: 'div-gpt-ad-1674608453701-0',
            ad_type: '',
            countryCodeEnabled: ['US'],
            style: {
                background: '#FFFFFF',
                border: '0.893041px solid #CBCDCE',
                borderRadius: '8px'
            }
        },
        {
            slot: '/22150725263/364x422-MyDNB-GAD-Offer-Desktop-3',
            width: 364,
            height: 422,
            ad_id: 'div-gpt-ad-1674608615126-0',
            className: 'rounded google-ads',
            key: 'desktop_2',
            ad_type: '',
            countryCodeEnabled: ['US'],
            style: {
                background: '#FFFFFF',
                border: '0.893041px solid #CBCDCE',
                borderRadius: '8px'
            }
        },
        {
            slot: '/22150725263/364x422-MyDNB-GAD-Offer-Desktop-4',
            width: 364,
            height: 422,
            ad_id: 'div-gpt-ad-1674608493595-0',
            className: 'rounded google-ads',
            key: 'desktop_3',
            ad_type: '',
            countryCodeEnabled: ['US'],
            style: {
                background: '#FFFFFF',
                border: '0.893041px solid #CBCDCE',
                borderRadius: '8px'
            }
        },
    ],
    tablet: [
        {
            slot: '/22150725263/339x456-MyDNB-GAD-Offer-Tablet-1',
            width: 339,
            height: 456,
            ad_id: 'div-gpt-ad-1674608054411-0',
            className: 'rounded google-ads',
            key: 'tablet_1',
            ad_type: '',
            countryCodeEnabled: ['US'],
            style: {
                background: '#FFFFFF',
                border: '0.893041px solid #CBCDCE',
                borderRadius: '8px'
            }
        },
        {
            slot: '/22150725263/339x456-MyDNB-GAD-Offer-Tablet-2',
            width: 339,
            height: 456,
            ad_id: 'div-gpt-ad-1674608084507-0',
            className: 'rounded google-ads',
            key: 'tablet_2',
            ad_type: '',
            countryCodeEnabled: ['US'],
            style: {
                background: '#FFFFFF',
                border: '0.893041px solid #CBCDCE',
                borderRadius: '8px'
            }
        },
        {
            slot: '/22150725263/339x456-MyDNB-GAD-Offer-Tablet-3',
            width: 339,
            height: 456,
            ad_id: 'div-gpt-ad-1674608194276-0',
            className: 'rounded google-ads',
            key: 'tablet_3',
            ad_type: '',
            countryCodeEnabled: ['US'],
            style: {
                background: '#FFFFFF',
                border: '0.893041px solid #CBCDCE',
                borderRadius: '8px'
            }
        },
        {
            slot: '/22150725263/339x456-MyDNB-GAD-Offer-Tablet-4',
            width: 339,
            height: 456,
            ad_id: 'div-gpt-ad-1674608214683-0',
            className: 'rounded google-ads',
            key: 'tablet_4',
            ad_type: '',
            countryCodeEnabled: ['US'],
            style: {
                background: '#FFFFFF',
                border: '0.893041px solid #CBCDCE',
                borderRadius: '8px'
            }
        }
    ],
    mobile: [
        {
            slot: '/22150725263/327x422-MyDNB-GAD-Offer-Mobile-1',
            width: 327,
            height: 422,
            ad_id: 'div-gpt-ad-1674608279519-0',
            className: 'rounded google-ads',
            key: 'mobile_1',
            ad_type: '',
            countryCodeEnabled: ['US'],
            style: {
                background: '#FFFFFF',
                border: '0.893041px solid #CBCDCE',
                borderRadius: '8px'
            }
        },
        {
            slot: '/22150725263/327x422-MyDNB-GAD-Offer-Mobile-2',
            width: 327,
            height: 422,
            ad_id: 'div-gpt-ad-1674608304988-0',
            className: 'rounded google-ads',
            key: 'mobile_2',
            ad_type: '',
            countryCodeEnabled: ['US'],
            style: {
                background: '#FFFFFF',
                border: '0.893041px solid #CBCDCE',
                borderRadius: '8px'
            }
        },
        {
            slot: '/22150725263/327x422-MyDNB-GAD-Offer-Mobile-3',
            width: 327,
            height: 422,
            ad_id: 'div-gpt-ad-1674608324073-0',
            className: 'rounded google-ads',
            key: 'mobile_3',
            ad_type: '',
            countryCodeEnabled: ['US'],
            style: {
                background: '#FFFFFF',
                border: '0.893041px solid #CBCDCE',
                borderRadius: '8px'
            }
        },
        {
            slot: '/22150725263/327x422-MyDNB-GAD-Offer-Mobile-4',
            width: 327,
            height: 422,
            ad_id: 'div-gpt-ad-1674608341758-0',
            className: 'rounded google-ads',
            key: 'mobile_4',
            ad_type: '',
            countryCodeEnabled: ['US'],
            style: {
                background: '#FFFFFF',
                border: '0.893041px solid #CBCDCE',
                borderRadius: '8px'
            }
        }
    ]
};

export const thirdPartyGoogleAdConfigList = {
    desktop: [
        {
            slot: '/22150725263/426x392-MyDNBOffer-Desktop-1',
            width: 426,
            height: 392,
            ad_id: 'div-gpt-ad-1659551038555-0',
            className: 'rounded google-ads',
            key: 'desktop_1',
            ad_type: '',
            countryCodeEnabled: ['US'],
            style: {
                background: '#FFFFFF',
                border: '0.893041px solid #CBCDCE',
                borderRadius: '8px'
            }
        },
        {
            slot: '/22150725263/426x392-MyDNBOffer-Desktop-2',
            width: 426,
            height: 392,
            ad_id: 'div-gpt-ad-1659551070600-0',
            className: 'rounded google-ads',
            key: 'desktop_2',
            ad_type: '',
            countryCodeEnabled: ['US'],
            style: {
                background: '#FFFFFF',
                border: '0.893041px solid #CBCDCE',
                borderRadius: '8px'
            }
        },
        {
            slot: '/22150725263/426x392-MyDNBOffer-Desktop-3',
            width: 426,
            height: 392,
            ad_id: 'div-gpt-ad-1659551097158-0',
            className: 'rounded google-ads',
            key: 'desktop_3',
            ad_type: '',
            countryCodeEnabled: ['US'],
            style: {
                background: '#FFFFFF',
                border: '0.893041px solid #CBCDCE',
                borderRadius: '8px'
            }
        },
        {
            slot: '/22150725263/426x392-MyDNBOffer-Desktop-4',
            width: 426,
            height: 392,
            ad_id: 'div-gpt-ad-1659551130379-0',
            className: 'rounded google-ads',
            key: 'desktop_4',
            ad_type: '',
            countryCodeEnabled: ['US'],
            style: {
                background: '#FFFFFF',
                border: '0.893041px solid #CBCDCE',
                borderRadius: '8px'
            }
        },
        {
            slot: '/22150725263/426x392-MyDNBOffer-Desktop-5',
            width: 426,
            height: 392,
            ad_id: 'div-gpt-ad-1677020280224-0',
            className: 'rounded google-ads',
            key: 'desktop_5',
            ad_type: '',
            countryCodeEnabled: ['US'],
            style: {
                background: '#FFFFFF',
                border: '0.893041px solid #CBCDCE',
                borderRadius: '8px'
            }
        }
    ],
    tablet: [
        {
            slot: '/22150725263/385x436-MyDNBOffer-Tablet-1',
            width: 385,
            height: 436,
            ad_id: 'div-gpt-ad-1659551442071-0',
            className: 'rounded google-ads',
            key: 'tablet_1',
            ad_type: '',
            countryCodeEnabled: ['US'],
            style: {
                background: '#FFFFFF',
                border: '0.893041px solid #CBCDCE',
                borderRadius: '8px'
            }
        },
        {
            slot: '/22150725263/385x436-MyDNBOffer-Tablet-2',
            width: 385,
            height: 436,
            ad_id: 'div-gpt-ad-1659551465484-0',
            className: 'rounded google-ads',
            key: 'tablet_2',
            ad_type: '',
            countryCodeEnabled: ['US'],
            style: {
                background: '#FFFFFF',
                border: '0.893041px solid #CBCDCE',
                borderRadius: '8px'
            }
        },
        {
            slot: '/22150725263/385x436-MyDNBOffer-Tablet-3',
            width: 385,
            height: 436,
            ad_id: 'div-gpt-ad-1659551487268-0',
            className: 'rounded google-ads',
            key: 'tablet_3',
            ad_type: '',
            countryCodeEnabled: ['US'],
            style: {
                background: '#FFFFFF',
                border: '0.893041px solid #CBCDCE',
                borderRadius: '8px'
            }
        },
        {
            slot: '/22150725263/385x436-MyDNBOffer-Tablet-4',
            width: 385,
            height: 436,
            ad_id: 'div-gpt-ad-1659551509455-0',
            className: 'rounded google-ads',
            key: 'tablet_4',
            ad_type: '',
            countryCodeEnabled: ['US'],
            style: {
                background: '#FFFFFF',
                border: '0.893041px solid #CBCDCE',
                borderRadius: '8px'
            }
        },
        {
            slot: '/22150725263/385x436-MyDNBOffer-Tablet-5',
            width: 385,
            height: 436,
            ad_id: 'div-gpt-ad-1677020317537-0',
            className: 'rounded google-ads',
            key: 'tablet_5',
            ad_type: '',
            countryCodeEnabled: ['US'],
            style: {
                background: '#FFFFFF',
                border: '0.893041px solid #CBCDCE',
                borderRadius: '8px'
            }
        }
    ],
    mobile: [
        {
            slot: '/22150725263/343x438-MyDNBOffer-Mobile-1',
            width: 343,
            height: 438,
            ad_id: 'div-gpt-ad-1659551705309-0',
            className: 'rounded google-ads',
            key: 'mobile_1',
            ad_type: '',
            countryCodeEnabled: ['US'],
            style: {
                background: '#FFFFFF',
                border: '0.893041px solid #CBCDCE',
                borderRadius: '8px'
            }
        },
        {
            slot: '/22150725263/343x438-MyDNBOffer-Mobile-2',
            width: 343,
            height: 438,
            ad_id: 'div-gpt-ad-1659551726805-0',
            className: 'rounded google-ads',
            key: 'mobile_2',
            ad_type: '',
            countryCodeEnabled: ['US'],
            style: {
                background: '#FFFFFF',
                border: '0.893041px solid #CBCDCE',
                borderRadius: '8px'
            }
        },
        {
            slot: '/22150725263/343x438-MyDNBOffer-Mobile-3',
            width: 343,
            height: 438,
            ad_id: 'div-gpt-ad-1659551747008-0',
            className: 'rounded google-ads',
            key: 'mobile_3',
            ad_type: '',
            countryCodeEnabled: ['US'],
            style: {
                background: '#FFFFFF',
                border: '0.893041px solid #CBCDCE',
                borderRadius: '8px'
            }
        },
        {
            slot: '/22150725263/343x438-MyDNBOffer-Mobile-4',
            width: 343,
            height: 438,
            ad_id: 'div-gpt-ad-1659551770050-0',
            className: 'rounded google-ads',
            key: 'mobile_4',
            ad_type: '',
            countryCodeEnabled: ['US'],
            style: {
                background: '#FFFFFF',
                border: '0.893041px solid #CBCDCE',
                borderRadius: '8px'
            }
        },
        {
            slot: '/22150725263/343x438-MyDNBOffer-Mobile-5',
            width: 343,
            height: 438,
            ad_id: 'div-gpt-ad-1677020446723-0',
            className: 'rounded google-ads',
            key: 'mobile_5',
            ad_type: '',
            countryCodeEnabled: ['US'],
            style: {
                background: '#FFFFFF',
                border: '0.893041px solid #CBCDCE',
                borderRadius: '8px'
            }
        }
    ]
};

export const recSectionGoogleAdConfigList = {
    desktop: [
        {
            slot: '/22150725263/300x250-MyDNB-portal-desktop-2',
            width: 300,
            height: 250,
            ad_id: 'div-gpt-ad-1656103532904-0',
            className: 'rounded',
            key: 'rec_product_desktop_2',
            ad_type: '',
            countryCodeEnabled: ['US'],
            style: {}
        },
        {
            slot: '/22150725263/300x250-MyDNB-portal-desktop-3',
            width: 300,
            height: 250,
            ad_id: 'div-gpt-ad-1656103560609-0',
            className: 'rounded',
            key: 'rec_product_desktop_3',
            ad_type: '',
            countryCodeEnabled: ['US'],
            style: {}
        }
    ],
    tablet: [
        {
            slot: '/22150725263/300x100-MyDNB-portal-mobile-2',
            width: 300,
            height: 250,
            ad_id: 'div-gpt-ad-1656103532904-0',
            className: 'rounded',
            key: 'rec_product_tablet_2',
            ad_type: '',
            countryCodeEnabled: ['US'],
            style: {}
        },
        {
            slot: '/22150725263/300x100-MyDNB-portal-mobile-3',
            width: 300,
            height: 250,
            ad_id: 'div-gpt-ad-1656103560609-0',
            className: 'rounded',
            key: 'rec_product_tablet_3',
            ad_type: '',
            countryCodeEnabled: ['US'],
            style: {}
        }
    ],
    mobile: [
        {
            slot: '/22150725263/300x100-MyDNB-portal-mobile-2',
            width: 300,
            height: 100,
            ad_id: 'div-gpt-ad-1645048947973-0',
            className: 'rounded',
            key: 'rec_product_mobile_2',
            ad_type: '',
            countryCodeEnabled: ['US'],
            style: {}
        },
        {
            slot: '/22150725263/300x100-MyDNB-portal-mobile-3',
            width: 300,
            height: 100,
            ad_id: 'div-gpt-ad-1645048983904-0',
            className: 'rounded',
            key: 'rec_product_mobile_3',
            ad_type: '',
            countryCodeEnabled: ['US'],
            style: {}
        }
    ]
};

export const productSectionGoogleAdConfigList = {
    desktop: [
        {
            slot: '/22150725263/300x250-MyDNB-portal-desktop-1',
            width: 300,
            height: 250,
            ad_id: 'div-gpt-ad-1656103482101-0',
            className: 'google-ads',
            key: 'product_desktop_1',
            ad_type: '',
            countryCodeEnabled: ['US', 'CA', 'IR', 'GB', 'IE'],
            style: {}
        }
    ],
    tablet: [
        {
            slot: '/22150725263/300x100-MyDNB-portal-mobile-1',
            width: 300,
            height: 250,
            ad_id: 'div-gpt-ad-1656103482101-0',
            className: 'rounded google-ads',
            key: 'product_tablet_1',
            ad_type: '',
            countryCodeEnabled: ['US', 'CA', 'IR', 'GB', 'IE'],
            style: {}
        }
    ],
    mobile: [
        {
            slot: '/22150725263/300x100-MyDNB-portal-mobile-1',
            width: 300,
            height: 100,
            ad_id: 'div-gpt-ad-1645048808578-0',
            className: 'rounded google-ads',
            key: 'product_mobile_1',
            ad_type: '',
            countryCodeEnabled: ['US', 'CA', 'IR', 'GB', 'IE'],
            style: {}
        }
    ]
};

export const productSectionInternationalGoogleAdConfigList = {
    desktop: [
        {
            slot: '/22150725263/300x250-International-Desktop-1',
            width: 300,
            height: 250,
            ad_id: 'div-gpt-ad-1698078913197-0',
            className: 'google-ads',
            key: 'product_desktop_1',
            ad_type: '',
            countryCodeEnabled: ['IR', 'GB', 'IE', 'HU', 'PL', 'CZ', 'CH', 'SI', 'SE', 'DK', 'NO', 'FI'],
            style: {}
        }
    ],
    tablet: [
        {
            slot: '/22150725263/300x250-International-Tablet-1',
            width: 300,
            height: 250,
            ad_id: 'div-gpt-ad-1698079173852-0',
            className: 'rounded google-ads',
            key: 'product_tablet_1',
            ad_type: '',
            countryCodeEnabled: ['IR', 'GB', 'IE', 'HU', 'PL', 'CZ', 'CH', 'SI', 'SE', 'DK', 'NO', 'FI'],
            style: {}
        }
    ],
    mobile: [
        {
            slot: '/22150725263/300x100-International-Mobile-1',
            width: 300,
            height: 100,
            ad_id: 'div-gpt-ad-1698079076288-0',
            className: 'rounded google-ads',
            key: 'product_mobile_1',
            ad_type: '',
            countryCodeEnabled: ['IR', 'GB', 'IE', 'HU', 'PL', 'CZ', 'CH', 'SI', 'SE', 'DK', 'NO', 'FI'],
            style: {}
        }
    ]
};

export const appId = 'APP_ID_PARTNER';

export const productIds = {
    nextInsurance: 'PRODUCT_ID_NEXT',
    lili: 'PRODUCT_ID_LILI',
    lendio: 'PRODUCT_ID_LENDIO'
};

export const partnerNameList = {
    lendio: 'LENDIO',
    nextInsurance: 'NEXT_INSURANCE',
    lili: 'LILI',
};

export const paymentSolutionsURL = 'https://www.paysafe.com/small-business/apply/400302/gen-001/psg-lp0010/?utm_source=400302&utm_medium=dnb&utm_campaign=nav&utm_content=solutions&utm_term=mydnb';

export const legalServicesURL = 'https://www.legalshield.com/db-thirdparty-leftnav/?utm_source=dun-bradstreet&utm_medium=display&utm_campaign=db-3p-leftnav';

export const legalLLCUrl = 'https://www.dnb.com/en-us/marketplace/product/tailor-brands-llc.html?utm_source=lhn';
export const FundabilityScanUrl = 'https://dnb.fundabilityscan.com/?utm_campaign=dnb-ui-account&utm_medium=pps&utm_source=dnb&afmc=1d'
export const taxAndAccountingUrl = 'https://vyde.io/small-business-tax-solution/?utm_source=dnb&utm_medium=partner&utm_campaign=nav%20menu';

export const infoToolTipSpecialCase = ['fundability-scan', 'tax-and-accounting'];


export const countryCodes = {
    US: 'US'
};

export const LendioMarketingURL = 'https://www.lendio.com/partner-dnb?source=DnB&affiliate=197503537&medium=Partner&campaign=Redirect&term=temporary';

export const CI_PLUS_PRODUCT_LIST = ['14767', '14768', '14772', '14769', '14770', '14771', '14773', '14774', '14775'];
export const ADVISORY_PRODUCT = '14799';